import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { fetchBaseQueryWrapper } from "./helpers";

export const activeDirectoryApi = createApi({
  reducerPath: "activeDirectory",
  baseQuery: fetchBaseQueryWrapper({
    path: "activeDirectory",
  }),
  endpoints: (build) => ({
    suggestActiveDirectory: build.query({
      query: ({ query, isEmailGroup = true }) =>
        `/suggestActiveDirectory/${query}${
          isEmailGroup ? "" : `?${new URLSearchParams({ isEmailGroup: false })}`
        }`,
      transformResponse: (response) => response.data,
    }),
    getActiveDirectory: build.query({
      query: ({ id }) => ({
        url: `${id}`,
        method: "GET",
      }),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const { useSuggestActiveDirectoryQuery, useGetActiveDirectoryQuery } =
  activeDirectoryApi;
